import { Typography } from '@mui/material'
import { WarningRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import createDialogTitle from '../../../generic/utilities/dialogUtil'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'

/**
 * Fix #2885: confirmation shown when a JOB is marked as Extern while it still carries values the
 * planner would read. Accepting marks the job and empties them; cancelling leaves the mark off.
 *
 * Story 146 (S63): "values the planner would read" now includes the preferred asset and the position
 * in the balanced line (RN27/RN30), so the warning names them as well.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onAccept
 * @param {Function} props.onCancel
 */
const ExternResetDialog = ({ open, onAccept, onCancel }) => {
  const { t_ } = useSmartTranslation()

  return (
    <SmartDialog
      setOpen={open}
      title={createDialogTitle({ title: t_('Mark as Extern'), icon: WarningRounded, color: 'warning' })}
      accept
      cancel
      acceptCallback={onAccept}
      cancelCallback={onCancel}
      renderComponent={
        <div data-testid='extern-reset-dialog'>
          <Typography sx={{ mb: 1 }}>
            {t_('A subcontracted job is not sized by the planner with our operators, preparation or task durations.')}
          </Typography>
          <Typography>
            {t_('Accepting will set the job operators, the preparation times and operators, and the task durations to zero.')}
          </Typography>
          {/* Story 146 (S63/RN27): the placement values are cleared by the same confirmation, so the
              warning has to name them too — the configurator is about to lose a choice he made. */}
          <Typography sx={{ mt: 1 }}>
            {t_('The preferred asset and the balanced line position are cleared for an external job')}
          </Typography>
        </div>
      }
    />
  )
}

export default ExternResetDialog
